module.exports = __webpack_public_path__ + "img/firmware_w.236228ab.svg";